import React from 'react';
type RichTextProps = {
  text: string;
};

/** Renders text, highlighting any [PLACEHOLDER] so pending content is easy to spot. */
export function RichText({
  text
}: RichTextProps) {
  const parts = text.split(/(\[[^\]]+\])/g);
  return <>
      {parts.map((part, i) => /^\[[^\]]+\]$/.test(part) ? <span key={i} className="rounded-md bg-accent-soft px-1.5 py-0.5 font-sans text-[0.78em] font-semibold not-italic tracking-normal text-accent-dark [box-decoration-break:clone]" data-id="element-194" data-mp="1g2j13vecpqmd">
            {part}
          </span> : <React.Fragment key={i} data-id="element-195" data-mp="1u0qwvzznilvy">{part}</React.Fragment>)}
    </>;
}